import {SVGProps, useId} from 'react';

import {COLORS} from '@/styles/colors';

export const LightbulbIcon = (props: SVGProps<SVGSVGElement>) => {
  const maskId = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? '24px'}
      height={props.height ?? '24px'}
      viewBox="0 0 24 24"
      fill="none"
      {...props}>
      <mask
        id={maskId}
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: 'alpha',
        }}>
        <path
          fill={COLORS.BACKGROUND_ON_SECONDARY_CONTAINER}
          d="M0 0h24v24H0z"
        />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          fill={props.color ?? COLORS.ON_SURFACE_1}
          d="M12 22.203c-.441 0-.849-.102-1.223-.306a2.276 2.276 0 0 1-.884-.856 2.128 2.128 0 0 1-1.488-.677 2.114 2.114 0 0 1-.608-1.514v-3.448a7.408 7.408 0 0 1-2.366-2.626 7.242 7.242 0 0 1-.884-3.526c0-2.068.725-3.828 2.175-5.278 1.45-1.45 3.21-2.175 5.278-2.175 2.069 0 3.828.725 5.278 2.175 1.45 1.45 2.175 3.21 2.175 5.278 0 1.3-.294 2.482-.884 3.548a7.464 7.464 0 0 1-2.366 2.604v3.448c0 .586-.203 1.09-.608 1.514-.406.424-.901.65-1.487.677a2.27 2.27 0 0 1-.888.856 2.514 2.514 0 0 1-1.22.306Zm-1.928-3.353h3.856v-.9h-3.856v.9Zm0-1.9h3.856V16h-3.856v.95ZM9.8 13.928h1.402v-2.61L9.54 9.655a.774.774 0 0 1 .006-1.116.763.763 0 0 1 .558-.237c.214 0 .4.08.558.237L12 9.884l1.344-1.345a.763.763 0 0 1 .558-.237c.214 0 .4.08.558.237a.763.763 0 0 1 .237.558c0 .214-.08.4-.237.558l-1.663 1.663v2.61H14.2a5.362 5.362 0 0 0 2.155-1.894c.549-.83.823-1.758.823-2.784 0-1.447-.501-2.671-1.504-3.674C14.672 4.573 13.447 4.072 12 4.072s-2.671.501-3.674 1.504C7.323 6.579 6.822 7.803 6.822 9.25c0 1.026.274 1.954.823 2.784A5.36 5.36 0 0 0 9.8 13.928Z"
        />
      </g>
    </svg>
  );
};
